import { render, staticRenderFns } from "./Localization.vue?vue&type=template&id=197f4dfc&scoped=true"
import script from "./Localization.vue?vue&type=script&lang=js"
export * from "./Localization.vue?vue&type=script&lang=js"
import style0 from "./Localization.vue?vue&type=style&index=0&id=197f4dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197f4dfc",
  null
  
)

export default component.exports